/* Layout types and other constants */
export const LAYOUT_VERTICAL = 'vertical';
export const LEFT_SIDEBAR_THEME_DEFAULT = 'default';
export const LEFT_SIDEBAR_THEME_DARK = 'dark';
export const LEFT_SIDEBAR_TYPE_CONDENSED = 'condensed';
